var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUploadHeader(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 32,
    viewBox: "0 0 23 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.25 0H11.5H1.1875C0.669312 0 0.25 0.419312 0.25 0.9375V31.0625C0.25 31.5807 0.669312 32 1.1875 32H11.5C11.5 32 21.2943 32 21.8125 32C22.3307 32 22.75 31.5807 22.75 31.0625V7.5L15.25 0Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.75 31.0625V7.5L15.25 0H11.5V32H21.8125C22.3307 32 22.75 31.5807 22.75 31.0625Z",
    fill: "#F5F7FA"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4753 5.89969L16.8503 0.274687C16.6746 0.098875 16.4365 0 16.1875 0H15.25V6.5625C15.25 7.08025 15.6697 7.5 16.1875 7.5H22.75V6.5625C22.75 6.3135 22.6511 6.07544 22.4753 5.89969Z",
    fill: "#DFE4EB"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0625 9.375H11.5H4.9375C4.41931 9.375 4 9.79431 4 10.3125V14.125C4 14.6432 4.41931 15.0625 4.9375 15.0625H11.5H18.0625C18.5807 15.0625 19 14.6432 19 14.125V10.3125C19 9.79431 18.5807 9.375 18.0625 9.375Z",
    fill: "#ADCCFA"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M19 14.125V10.3125C19 9.79431 18.5807 9.375 18.0625 9.375H11.5V15.0625H18.0625C18.5807 15.0625 19 14.6432 19 14.125Z",
    fill: "#9BB2D1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadHeader);
export default __webpack_public_path__ + "static/media/uploadHeader.1cc98434142da96018543ea3e99dbd14.svg";
export { ForwardRef as ReactComponent };